<template>
  <AppToast />
  <AppSidebar :onClick="onHandleClick">
    <template #app-sidebar>
      <PublisherSidebar />
    </template>
  </AppSidebar>
  <div class="wrapper d-flex flex-column min-vh-100 bg-light">
    <PublisherHeader :username="username" />
    <div class="body flex-grow-1 px-3">
      <CContainer lg>
        <router-view />
      </CContainer>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import routerPublisher from '@/publisher/router'
import storePublisher from '@/publisher/store'
import { CContainer } from '@coreui/vue'
import AppFooter from '@/components/app/AppFooter.vue'
import AppSidebar from '@/components/app/AppSidebar.vue'
import AppToast from '@/components/app/AppToast.vue'
import PublisherHeader from '@/publisher/views/Header.vue'
import PublisherSidebar from '@/publisher/views/Sidebar.vue'

export default {
  name: 'PublisherLayout',

  components: {
    AppFooter,
    AppSidebar,
    AppToast,
    PublisherHeader,
    PublisherSidebar,
    CContainer,
  },

  computed: {
    username() {
      return storePublisher.state.publishers.user?.username
    },
  },

  methods: {
    onHandleClick() {
      routerPublisher.push('/leads')
    },
  },
}
</script>
